import React, { useState, useContext } from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import { PermissionsContext } from 'contexts/PermissionsContext';
import { BudgetTableContainer } from './BudgetTable';
import { BudgetOverviewContainer } from './BudgetOverview';
import { BudgetPerformanceContainer } from './BudgetPerformance';
import { Wrapper } from './BudgetTracker.styles';
import { CONFIG } from './routes';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { getCurrencySymbolFromOptions } from 'Details/utils';
import { PLAN_AND_TRACK_NAV_CONFIG } from './utils';
import { ApButtonTab, ApSecondaryNav } from '@alixpartners/ui-components';
import { NavLink, useLocation } from 'react-router-dom';

export const BudgetTracker = ({ currencySymbol, currency, permissions }) => {
	const [tableData, setTableData] = useState(null);
	const [ignoreCache, setIgnoreCache] = useState(true);
	const location = useLocation();

	const hasSomePermissions = requiredSome => {
		return !requiredSome || requiredSome.some(i => permissions.includes(i));
	};

	return (
		<Wrapper>
			<ApSecondaryNav
				left={PLAN_AND_TRACK_NAV_CONFIG.map(
					({ label, path, disabled, requiredSome }) => {
						return (
							<NavLink
								to={path}
								key={path}
								disabled={disabled || !hasSomePermissions(requiredSome)}
							>
								<ApButtonTab
									isSelected={
										path === '/budget' ? true : location.pathname === path
									}
									disabled={disabled || !hasSomePermissions(requiredSome)}
								>
									{label}
								</ApButtonTab>
							</NavLink>
						);
					}
				)}
			/>
			<Switch>
				{CONFIG.map(({ name, path }) => {
					return (
						<Route
							key={path}
							path={path}
							render={routerProps => {
								if (name === 'table') {
									return (
										<BudgetTableContainer
											tableData={tableData}
											setTableData={setTableData}
											ignoreCache={ignoreCache}
											setIgnoreCache={setIgnoreCache}
										/>
									);
								}

								if (name === 'performance') {
									return (
										<BudgetPerformanceContainer
											currencySymbol={currencySymbol}
										/>
									);
								}

								return (
									<BudgetOverviewContainer
										currencySymbol={currencySymbol}
										currency={currency}
										{...routerProps}
									/>
								);
							}}
						/>
					);
				})}

				<Redirect to={CONFIG.find(item => !item.disabled).path} />
			</Switch>
		</Wrapper>
	);
};

export default props => {
	const { currency } = useContext(QueryStringContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);

	return (
		<PermissionsContext.Consumer>
			{({ permissions }) => (
				<BudgetTracker
					{...props}
					permissions={permissions || []}
					currencySymbol={currencySymbol}
					currency={currency}
				/>
			)}
		</PermissionsContext.Consumer>
	);
};
